import React from "react";
import BaseAutocomplete from "components/Shared/Base/BaseAutocomplete";
import { useLazySearchUsersQuery } from "store/services/userApi";

const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = React.useState(value);
    React.useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);
    return debouncedValue;
};

const UserSearchAutocomplete = ({ label, value, onChange }) => {
    const [userSearch, setUserSearch] = React.useState("");
    const debouncedUserSearch = useDebounce(userSearch, 400);
    const [triggerUsersDDL, { data: userOptions = [] }] =
        useLazySearchUsersQuery();

    React.useEffect(() => {
        if (debouncedUserSearch.trim().length < 3) return;
        triggerUsersDDL({ q: debouncedUserSearch });
    }, [debouncedUserSearch, triggerUsersDDL]);

    return (
        <BaseAutocomplete
            fullWidth
            label={label}
            placeholder="Type at least 3 characters..."
            options={userOptions}
            getOptionLabel={(opt) => opt?.name || ""}
            isOptionEqualToValue={(o, v) => o?._id === v?._id}
            value={value}
            onChange={(_, v) => onChange(v)}
            onInputChange={(_, v) => setUserSearch(v || "")}
            noOptionsText={
                userSearch.length < 3
                    ? "Type at least 3 characters..."
                    : "No users found"
            }
        />
    );
};

export default UserSearchAutocomplete;